import * as React from "react";
import PropTypes from "prop-types";

interface CalendarIconProps extends React.SVGProps<SVGSVGElement> {
  fill?: string;
  width?: string | number;
  height?: string | number;
}

const CalendarIcon: React.FC<CalendarIconProps> = ({ fill = "#1581ED", ...props }) => (
  <svg
    width={props?.width ?? 17}
    height={props?.height ?? 16}
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.4088 3.43385C12.1272 3.43385 11.8987 3.2039 11.8987 2.92057V0.513281C11.8987 0.22995 12.1272 0 12.4088 0C12.6903 0 12.9188 0.22995 12.9188 0.513281V2.92057C12.9188 3.2039 12.6903 3.43385 12.4088 3.43385Z"
      fill={fill}
    />
    <path
      d="M3.94857 3.43385C3.66704 3.43385 3.43855 3.2039 3.43855 2.92057V0.513281C3.43855 0.22995 3.66704 0 3.94857 0C4.2301 0 4.45859 0.22995 4.45859 0.513281V2.92057C4.45859 3.2039 4.2301 3.43385 3.94857 3.43385Z"
      fill={fill}
    />
    <path
      d="M16.29 6.23582H0.510018C0.228488 6.23582 0 6.00587 0 5.72254C0 5.43921 0.228488 5.20926 0.510018 5.20926H16.29C16.5715 5.20926 16.8 5.43921 16.8 5.72254C16.8 6.00587 16.5715 6.23582 16.29 6.23582Z"
      fill={fill}
    />
    <path
      d="M15.0705 16H1.72947C0.775737 16 0 15.2193 0 14.2595V3.04427C0 2.08444 0.775737 1.30322 1.72947 1.30322H15.07C16.0237 1.30322 16.7995 2.08392 16.7995 3.04376V14.259C16.7995 15.2188 16.0237 15.9995 15.07 15.9995L15.0705 16ZM1.72947 2.32978C1.33829 2.32978 1.02004 2.65007 1.02004 3.04376V14.259C1.02004 14.6526 1.33829 14.9729 1.72947 14.9729H15.07C15.4612 14.9729 15.7794 14.6526 15.7794 14.259V3.04427C15.7794 2.65059 15.4612 2.3303 15.07 2.3303H1.72947V2.32978Z"
      fill={fill}
    />
    <path
      d="M4.48202 7.66736H3.41506C3.31714 7.66736 3.22687 7.7192 3.17739 7.80389L2.64901 8.70675C2.59801 8.7935 2.59801 8.9018 2.64901 8.98854L3.17739 9.89141C3.22687 9.9761 3.31765 10.0279 3.41506 10.0279H4.48202C4.57994 10.0279 4.67022 9.9761 4.71969 9.89141L5.24807 8.98854C5.29907 8.9018 5.29907 8.7935 5.24807 8.70675L4.71969 7.80389C4.67022 7.7192 4.57943 7.66736 4.48202 7.66736Z"
      fill={fill}
    />
    <path
      d="M4.48202 11.2876H3.41506C3.31714 11.2876 3.22687 11.3394 3.17739 11.4241L2.64901 12.327C2.59801 12.4137 2.59801 12.522 2.64901 12.6088L3.17739 13.5116C3.22687 13.5963 3.31765 13.6481 3.41506 13.6481H4.48202C4.57994 13.6481 4.67022 13.5963 4.71969 13.5116L5.24807 12.6088C5.29907 12.522 5.29907 12.4137 5.24807 12.327L4.71969 11.4241C4.67022 11.3394 4.57943 11.2876 4.48202 11.2876Z"
      fill={fill}
    />
    <path
      d="M12.9422 7.66736H11.8753C11.7773 7.66736 11.6871 7.7192 11.6376 7.80389L11.1092 8.70675C11.0582 8.7935 11.0582 8.9018 11.1092 8.98854L11.6376 9.89141C11.6871 9.9761 11.7778 10.0279 11.8753 10.0279H12.9422C13.0401 10.0279 13.1304 9.9761 13.1799 9.89141L13.7083 8.98854C13.7593 8.9018 13.7593 8.7935 13.7083 8.70675L13.1799 7.80389C13.1304 7.7192 13.0396 7.66736 12.9422 7.66736Z"
      fill={fill}
    />
    <path
      d="M12.9422 11.2876H11.8753C11.7773 11.2876 11.6871 11.3394 11.6376 11.4241L11.1092 12.327C11.0582 12.4137 11.0582 12.522 11.1092 12.6088L11.6376 13.5116C11.6871 13.5963 11.7778 13.6481 11.8753 13.6481H12.9422C13.0401 13.6481 13.1304 13.5963 13.1799 13.5116L13.7083 12.6088C13.7593 12.522 13.7593 12.4137 13.7083 12.327L13.1799 11.4241C13.1304 11.3394 13.0396 11.2876 12.9422 11.2876Z"
      fill={fill}
    />
    <path
      d="M8.8233 7.66736H7.75634C7.65842 7.66736 7.56814 7.7192 7.51867 7.80389L6.99029 8.70675C6.93929 8.7935 6.93929 8.9018 6.99029 8.98854L7.51867 9.89141C7.56814 9.9761 7.65893 10.0279 7.75634 10.0279H8.8233C8.92122 10.0279 9.0115 9.9761 9.06097 9.89141L9.58935 8.98854C9.64035 8.9018 9.64035 8.7935 9.58935 8.70675L9.06097 7.80389C9.0115 7.7192 8.92071 7.66736 8.8233 7.66736Z"
      fill={fill}
    />
    <path
      d="M8.8233 11.2876H7.75634C7.65842 11.2876 7.56814 11.3394 7.51867 11.4241L6.99029 12.327C6.93929 12.4137 6.93929 12.522 6.99029 12.6088L7.51867 13.5116C7.56814 13.5963 7.65893 13.6481 7.75634 13.6481H8.8233C8.92122 13.6481 9.0115 13.5963 9.06097 13.5116L9.58935 12.6088C9.64035 12.522 9.64035 12.4137 9.58935 12.327L9.06097 11.4241C9.0115 11.3394 8.92071 11.2876 8.8233 11.2876Z"
      fill={fill}
    />
  </svg>
);
CalendarIcon.propTypes = {
  fill: PropTypes.string,
};
export default CalendarIcon;
